/*
 * DefinitionTermField.tsx
 * Un composant de champ de définition (terme dt) avec un style personnalisé.
 * A utiliser avec un champ de définition (description dd) le tout dans une liste de définitions (dl).
 */

import React from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import '@radix-ui/themes/styles.css';
import '../../styles/global.css';

// Définition des props du composant
interface DefinitionTermFieldProps {
	label: string;
	tooltip?: string;
	className?: string;
}

// DefinitionTermField component
const DefinitionTermField: React.FC<DefinitionTermFieldProps> = ({
	label,
	tooltip,
	className,
}) => {
	const termClass = `text-gray-500 ${className ?? ''}`;
	// Rendu du composant
	if (tooltip) {
		return (
			<Tooltip.Provider>
				<Tooltip.Root>
					<Tooltip.Trigger asChild>
						<div className="cursor-help">
							<dt className={termClass}>{label}</dt>
						</div>
					</Tooltip.Trigger>
					<Tooltip.Content
						side="top"
						align="center"
						className="bg-gray-800 text-white text-xs rounded px-2 py-1"
					>
						<div className="text-sm max-w-xs">{tooltip}</div>

						<Tooltip.Arrow className="fill-current text-gray-800" />
					</Tooltip.Content>
				</Tooltip.Root>
			</Tooltip.Provider>
		);
	} else {
		return <dt className={termClass}>{label}</dt>;
	}
};

// Export du composant
export default DefinitionTermField;
